var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c(
          "el-card",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "card normal-page",
          },
          [
            _c(
              "div",
              { staticClass: "main" },
              [
                _c(
                  "div",
                  { staticClass: "search" },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: {
                          placeholder: "搜索功能和帮助",
                          "prefix-icon": "el-icon-search",
                        },
                        on: { change: _vm.getList },
                        model: {
                          value: _vm.keyword,
                          callback: function ($$v) {
                            _vm.keyword = $$v
                          },
                          expression: "keyword",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { slot: "suffix", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.getList()
                              },
                            },
                            slot: "suffix",
                          },
                          [_vm._v(" 搜索")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tab" },
                  [
                    _c(
                      "el-tabs",
                      {
                        on: { "tab-click": _vm.handleClick },
                        model: {
                          value: _vm.activeName,
                          callback: function ($$v) {
                            _vm.activeName = $$v
                          },
                          expression: "activeName",
                        },
                      },
                      _vm._l(_vm.noticeNav, function (item, index) {
                        return _c("el-tab-pane", {
                          key: item.val,
                          attrs: { label: item.name, name: item.val },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.dataList, function (item, index) {
                  return _c("div", { key: index }, [
                    item.type == "document"
                      ? _c(
                          "div",
                          {
                            staticClass: "content",
                            on: {
                              click: function ($event) {
                                return _vm.openHelp(item)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "header" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm.labelText == "全部"
                                  ? _c("span", { staticClass: "text" }, [
                                      _vm._v("【操作手册】"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      item.question == ""
                                        ? item.title
                                        : item.question
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "read" }, [
                                _c("span", {
                                  staticClass:
                                    "iconfont iconzuozhezhongxin-chuangzuozhongxin",
                                }),
                                _vm._v(" " + _vm._s(item.visit)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "article over-text2" }, [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(item.content) },
                              }),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    item.type == "article"
                      ? _c(
                          "div",
                          {
                            staticClass: "content",
                            on: {
                              click: function ($event) {
                                return _vm.openArticle(item)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "header" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm.labelText == "全部"
                                  ? _c("span", { staticClass: "text color1" }, [
                                      _vm._v("【知识社区】"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(item.title) },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "read" }, [
                                _c("span", {
                                  staticClass:
                                    "iconfont iconzuozhezhongxin-chuangzuozhongxin",
                                }),
                                _vm._v(" " + _vm._s(item.visit)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "article over-text2" }, [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(item.content) },
                              }),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    item.type == "file" && item.unlock == 0
                      ? _c(
                          "div",
                          {
                            staticClass: "content",
                            on: {
                              click: function ($event) {
                                return _vm.proview(item)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "header" }, [
                              _c("div", { staticClass: "title" }, [
                                _c("span", {
                                  staticClass: "iconfont iconbiaoge",
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(item.title) },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "read" }, [
                                _c("span", {
                                  staticClass:
                                    "iconfont iconzuozhezhongxin-chuangzuozhongxin",
                                }),
                                _vm._v(" " + _vm._s(item.visit)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-end mt15" }, [
                              _c("span", { staticClass: "icon" }, [
                                _vm._v("￥"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "num" }, [
                                _vm._v(_vm._s(item.price)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "use" }, [
                                _vm._v(_vm._s(item.download) + "人使用"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "down",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.fileDown(item)
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "iconfont iconxiazai",
                                  }),
                                  _vm._v("下载"),
                                ]
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    item.type == "file" && item.unlock == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "content",
                            on: {
                              click: function ($event) {
                                return _vm.proview(item)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "header" }, [
                              _c("div", { staticClass: "title" }, [
                                _c("span", { staticClass: "iconfont iconppt" }),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(item.title) },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "read" }, [
                                _c("span", {
                                  staticClass:
                                    "iconfont iconzuozhezhongxin-chuangzuozhongxin",
                                }),
                                _vm._v(" " + _vm._s(item.visit)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-end mt15" }, [
                              _c("span", { staticClass: "free" }, [
                                _vm._v("免费"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "use" }, [
                                _vm._v(_vm._s(item.download) + "人使用"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "down",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.fileDown(item)
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "iconfont iconxiazai",
                                  }),
                                  _vm._v("下载"),
                                ]
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ])
                }),
                _vm._v(" "),
                _vm.dataList.length == 0
                  ? _c("div", { staticClass: "default" }, [
                      _c("img", {
                        attrs: {
                          alt: "",
                          src: require("../../assets/images/help.png"),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("暂无搜索结果~"),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
        _vm._v(" "),
        _c("payment", {
          ref: "payment",
          attrs: { "from-data": _vm.payData },
          on: { isOk: _vm.getList },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }